var _excluded = ["fill", "fillOpacity", "cursor"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isObject } from 'vega';
import { array, stringValue } from 'vega-util';
import { STORE, TUPLE, unitName } from '.';
import { LATITUDE, LONGITUDE, X, Y } from '../../channel';
import { warn } from '../../log';
import { hasContinuousDomain } from '../../scale';
import { SELECTION_ID } from '../../selection';
import { keys, vals } from '../../util';
import { isUnitModel } from '../model';
import { assembleInit } from './assemble';
import { TUPLE_FIELDS } from './project';
import scales from './scales';
export var BRUSH = '_brush';
export var SCALE_TRIGGER = '_scale_trigger';
export var GEO_INIT_TICK = 'geo_interval_init_tick'; // Workaround for https://github.com/vega/vega/issues/3481
var INIT = '_init';
var CENTER = '_center';
var interval = {
  defined: function defined(selCmpt) {
    return selCmpt.type === 'interval';
  },
  parse: function parse(model, selCmpt, selDef) {
    var _a;
    if (model.hasProjection) {
      var def = _objectSpread({}, isObject(selDef.select) ? selDef.select : {});
      def.fields = [SELECTION_ID];
      if (!def.encodings) {
        // Remap default x/y projection
        def.encodings = selDef.value ? keys(selDef.value) : [LONGITUDE, LATITUDE];
      }
      selDef.select = _objectSpread({
        type: 'interval'
      }, def);
    }
    if (selCmpt.translate && !scales.defined(selCmpt)) {
      var filterExpr = "!event.item || event.item.mark.name !== ".concat(stringValue(selCmpt.name + BRUSH));
      var _iterator = _createForOfIteratorHelper(selCmpt.events),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _a$filter;
          var evt = _step.value;
          if (!evt.between) {
            warn("".concat(evt, " is not an ordered event stream for interval selections."));
            continue;
          }
          var filters = array((_a$filter = (_a = evt.between[0]).filter) !== null && _a$filter !== void 0 ? _a$filter : _a.filter = []);
          if (!filters.includes(filterExpr)) {
            filters.push(filterExpr);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  },
  signals: function signals(model, selCmpt, _signals) {
    var name = selCmpt.name;
    var tupleSg = name + TUPLE;
    var channels = vals(selCmpt.project.hasChannel).filter(function (p) {
      return p.channel === X || p.channel === Y;
    });
    var init = selCmpt.init ? selCmpt.init[0] : null;
    _signals.push.apply(_signals, _toConsumableArray(channels.reduce(function (arr, proj) {
      return arr.concat(channelSignals(model, selCmpt, proj, init && init[proj.index]));
    }, [])));
    if (!model.hasProjection) {
      // Proxy scale reactions to ensure that an infinite loop doesn't occur
      // when an interval selection filter touches the scale.
      if (!scales.defined(selCmpt)) {
        var triggerSg = name + SCALE_TRIGGER;
        var scaleTriggers = channels.map(function (proj) {
          var channel = proj.channel;
          var _proj$signals = proj.signals,
            dname = _proj$signals.data,
            vname = _proj$signals.visual;
          var scaleName = stringValue(model.scaleName(channel));
          var scaleType = model.getScaleComponent(channel).get('type');
          var toNum = hasContinuousDomain(scaleType) ? '+' : '';
          return "(!isArray(".concat(dname, ") || ") + "(".concat(toNum, "invert(").concat(scaleName, ", ").concat(vname, ")[0] === ").concat(toNum).concat(dname, "[0] && ") + "".concat(toNum, "invert(").concat(scaleName, ", ").concat(vname, ")[1] === ").concat(toNum).concat(dname, "[1]))");
        });
        if (scaleTriggers.length) {
          _signals.push({
            name: triggerSg,
            value: {},
            on: [{
              events: channels.map(function (proj) {
                return {
                  scale: model.scaleName(proj.channel)
                };
              }),
              update: scaleTriggers.join(' && ') + " ? ".concat(triggerSg, " : {}")
            }]
          });
        }
      }
      // Only add an interval to the store if it has valid data extents. Data extents
      // are set to null if pixel extents are equal to account for intervals over
      // ordinal/nominal domains which, when inverted, will still produce a valid datum.
      var dataSignals = channels.map(function (proj) {
        return proj.signals.data;
      });
      var update = "unit: ".concat(unitName(model), ", fields: ").concat(name + TUPLE_FIELDS, ", values");
      return _signals.concat(_objectSpread(_objectSpread({
        name: tupleSg
      }, init ? {
        init: "{".concat(update, ": ").concat(assembleInit(init), "}")
      } : {}), dataSignals.length ? {
        on: [{
          events: [{
            signal: dataSignals.join(' || ')
          }],
          // Prevents double invocation, see https://github.com/vega/vega/issues/1672.
          update: "".concat(dataSignals.join(' && '), " ? {").concat(update, ": [").concat(dataSignals, "]} : null")
        }]
      } : {}));
    } else {
      var projection = stringValue(model.projectionName());
      var centerSg = model.projectionName() + CENTER;
      var _selCmpt$project$hasC = selCmpt.project.hasChannel,
        x = _selCmpt$project$hasC.x,
        y = _selCmpt$project$hasC.y;
      var xvname = x && x.signals.visual;
      var yvname = y && y.signals.visual;
      var xinit = x ? init && init[x.index] : "".concat(centerSg, "[0]");
      var yinit = y ? init && init[y.index] : "".concat(centerSg, "[1]");
      var sizeSg = function sizeSg(layout) {
        return model.getSizeSignalRef(layout).signal;
      };
      var bbox = "[" + "[".concat(xvname ? xvname + '[0]' : '0', ", ").concat(yvname ? yvname + '[0]' : '0', "],") + "[".concat(xvname ? xvname + '[1]' : sizeSg('width'), ", ") + "".concat(yvname ? yvname + '[1]' : sizeSg('height'), "]") + "]";
      if (init) {
        _signals.unshift({
          name: name + INIT,
          init: "[scale(".concat(projection, ", [").concat(x ? xinit[0] : xinit, ", ").concat(y ? yinit[0] : yinit, "]), ") + "scale(".concat(projection, ", [").concat(x ? xinit[1] : xinit, ", ").concat(y ? yinit[1] : yinit, "])]")
        });
        if (!x || !y) {
          // If initializing a uni-dimensional brush, use the center of the view to determine the other coord
          var hasCenterSg = _signals.find(function (s) {
            return s.name === centerSg;
          });
          if (!hasCenterSg) {
            _signals.unshift({
              name: centerSg,
              update: "invert(".concat(projection, ", [").concat(sizeSg('width'), "/2, ").concat(sizeSg('height'), "/2])")
            });
          }
        }
      }
      var intersect = "intersect(".concat(bbox, ", {markname: ").concat(stringValue(model.getName('marks')), "}, unit.mark)");
      var base = "{unit: ".concat(unitName(model), "}");
      var _update = "vlSelectionTuples(".concat(intersect, ", ").concat(base, ")");
      var visualSignals = channels.map(function (proj) {
        return proj.signals.visual;
      });
      return _signals.concat({
        name: tupleSg,
        on: [{
          events: [].concat(_toConsumableArray(visualSignals.length ? [{
            signal: visualSignals.join(' || ')
          }] : []), _toConsumableArray(init ? [{
            signal: GEO_INIT_TICK
          }] : [])),
          update: _update
        }]
      });
    }
  },
  topLevelSignals: function topLevelSignals(model, selCmpt, signals) {
    if (isUnitModel(model) && model.hasProjection && selCmpt.init) {
      // Workaround for https://github.com/vega/vega/issues/3481
      // The scenegraph isn't populated on the first pulse. So we use a timer signal
      // to re-pulse the dataflow as soon as possible. We return an object to ensure
      // this only occurs once.
      var hasTick = signals.filter(function (s) {
        return s.name === GEO_INIT_TICK;
      });
      if (!hasTick.length) {
        signals.unshift({
          name: GEO_INIT_TICK,
          value: null,
          on: [{
            events: 'timer{1}',
            update: "".concat(GEO_INIT_TICK, " === null ? {} : ").concat(GEO_INIT_TICK)
          }]
        });
      }
    }
    return signals;
  },
  marks: function marks(model, selCmpt, _marks) {
    var name = selCmpt.name;
    var _selCmpt$project$hasC2 = selCmpt.project.hasChannel,
      x = _selCmpt$project$hasC2.x,
      y = _selCmpt$project$hasC2.y;
    var xvname = x === null || x === void 0 ? void 0 : x.signals.visual;
    var yvname = y === null || y === void 0 ? void 0 : y.signals.visual;
    var store = "data(".concat(stringValue(selCmpt.name + STORE), ")");
    // Do not add a brush if we're binding to scales
    // or we don't have a valid interval projection
    if (scales.defined(selCmpt) || !x && !y) {
      return _marks;
    }
    var update = {
      x: x !== undefined ? {
        signal: "".concat(xvname, "[0]")
      } : {
        value: 0
      },
      y: y !== undefined ? {
        signal: "".concat(yvname, "[0]")
      } : {
        value: 0
      },
      x2: x !== undefined ? {
        signal: "".concat(xvname, "[1]")
      } : {
        field: {
          group: 'width'
        }
      },
      y2: y !== undefined ? {
        signal: "".concat(yvname, "[1]")
      } : {
        field: {
          group: 'height'
        }
      }
    };
    // If the selection is resolved to global, only a single interval is in
    // the store. Wrap brush mark's encodings with a production rule to test
    // this based on the `unit` property. Hide the brush mark if it corresponds
    // to a unit different from the one in the store.
    if (selCmpt.resolve === 'global') {
      var _iterator2 = _createForOfIteratorHelper(keys(update)),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var key = _step2.value;
          update[key] = [_objectSpread({
            test: "".concat(store, ".length && ").concat(store, "[0].unit === ").concat(unitName(model))
          }, update[key]), {
            value: 0
          }];
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    // Two brush marks ensure that fill colors and other aesthetic choices do
    // not interefere with the core marks, but that the brushed region can still
    // be interacted with (e.g., dragging it around).
    var _selCmpt$mark = selCmpt.mark,
      fill = _selCmpt$mark.fill,
      fillOpacity = _selCmpt$mark.fillOpacity,
      cursor = _selCmpt$mark.cursor,
      stroke = _objectWithoutProperties(_selCmpt$mark, _excluded);
    var vgStroke = keys(stroke).reduce(function (def, k) {
      def[k] = [{
        test: [x !== undefined && "".concat(xvname, "[0] !== ").concat(xvname, "[1]"), y !== undefined && "".concat(yvname, "[0] !== ").concat(yvname, "[1]")].filter(function (t) {
          return t;
        }).join(' && '),
        value: stroke[k]
      }, {
        value: null
      }];
      return def;
    }, {});
    // Set cursor to move unless the brush cannot be translated
    var vgCursor = cursor !== null && cursor !== void 0 ? cursor : selCmpt.translate ? 'move' : null;
    return [{
      name: "".concat(name + BRUSH, "_bg"),
      type: 'rect',
      clip: true,
      encode: {
        enter: {
          fill: {
            value: fill
          },
          fillOpacity: {
            value: fillOpacity
          }
        },
        update: update
      }
    }].concat(_toConsumableArray(_marks), [{
      name: name + BRUSH,
      type: 'rect',
      clip: true,
      encode: {
        enter: _objectSpread(_objectSpread({}, vgCursor ? {
          cursor: {
            value: vgCursor
          }
        } : {}), {}, {
          fill: {
            value: 'transparent'
          }
        }),
        update: _objectSpread(_objectSpread({}, update), vgStroke)
      }
    }]);
  }
};
export default interval;
/**
 * Returns the visual and data signals for an interval selection.
 */
function channelSignals(model, selCmpt, proj, init) {
  var scaledInterval = !model.hasProjection;
  var channel = proj.channel;
  var vname = proj.signals.visual;
  var scaleName = stringValue(scaledInterval ? model.scaleName(channel) : model.projectionName());
  var scaled = function scaled(str) {
    return "scale(".concat(scaleName, ", ").concat(str, ")");
  };
  var size = model.getSizeSignalRef(channel === X ? 'width' : 'height').signal;
  var coord = "".concat(channel, "(unit)");
  var von = selCmpt.events.reduce(function (def, evt) {
    return [].concat(_toConsumableArray(def), [{
      events: evt.between[0],
      update: "[".concat(coord, ", ").concat(coord, "]")
    },
    // Brush Start
    {
      events: evt,
      update: "[".concat(vname, "[0], clamp(").concat(coord, ", 0, ").concat(size, ")]")
    } // Brush End
    ]);
  }, []);
  if (scaledInterval) {
    var dname = proj.signals.data;
    var hasScales = scales.defined(selCmpt);
    var scale = model.getScaleComponent(channel);
    var scaleType = scale ? scale.get('type') : undefined;
    var vinit = init ? {
      init: assembleInit(init, true, scaled)
    } : {
      value: []
    };
    // React to pan/zooms of continuous scales. Non-continuous scales
    // (band, point) cannot be pan/zoomed and any other changes
    // to their domains (e.g., filtering) should clear the brushes.
    von.push({
      events: {
        signal: selCmpt.name + SCALE_TRIGGER
      },
      update: hasContinuousDomain(scaleType) ? "[".concat(scaled("".concat(dname, "[0]")), ", ").concat(scaled("".concat(dname, "[1]")), "]") : "[0, 0]"
    });
    return hasScales ? [{
      name: dname,
      on: []
    }] : [_objectSpread(_objectSpread({
      name: vname
    }, vinit), {}, {
      on: von
    }), _objectSpread(_objectSpread({
      name: dname
    }, init ? {
      init: assembleInit(init)
    } : {}), {}, {
      // Cannot be `value` as `init` may require datetime exprs.
      on: [{
        events: {
          signal: vname
        },
        update: "".concat(vname, "[0] === ").concat(vname, "[1] ? null : invert(").concat(scaleName, ", ").concat(vname, ")")
      }]
    })];
  } else {
    var initIdx = channel === X ? 0 : 1;
    var initSg = selCmpt.name + INIT;
    var _vinit = init ? {
      init: "[".concat(initSg, "[0][").concat(initIdx, "], ").concat(initSg, "[1][").concat(initIdx, "]]")
    } : {
      value: []
    };
    return [_objectSpread(_objectSpread({
      name: vname
    }, _vinit), {}, {
      on: von
    })];
  }
}